/* VialArt / VialCase — per-design logo slot defaults.
   Some designs reserve a logo zone (e.g. "Holo Exclusive": the emblem spot,
   top-left). When a customer logo exists while such a design is selected and
   the logo is still at the untouched default placement (center, scale 1),
   snap it into the design's slot. The customer can still drag/scale freely
   afterwards. Coordinates ride the normal logoScale/logoX/logoY props, so
   server-side print parity is automatic. Identical file on BOTH themes. */
(function () {
  var SLOTS = {
    // key: [scale, xOffsetMm, yOffsetMm] (offsets from label center, y-down)
    lux_onyx_holo: [0.5, -17.88, -5.93]
  };
  function untouched() {
    var s = (window.logoScale == null ? 1 : +window.logoScale);
    var x = (+window.logoX || 0), y = (+window.logoY || 0);
    return Math.abs(s - 1) < 0.001 && Math.abs(x) < 0.001 && Math.abs(y) < 0.001;
  }
  function apply() {
    try {
      var d = window.sel;
      if (!d || !SLOTS[d.key]) return;
      if (!window.customLogo) return;
      if (!untouched()) return;
      var c = SLOTS[d.key];
      window.logoScale = c[0];
      window.logoX = c[1];
      window.logoY = c[2];
      var sl = document.getElementById('va-logo-scale');
      if (sl) { try { sl.value = c[0]; } catch (e) {} }
      if (typeof window.renderAll === 'function') window.renderAll();
      else {
        var n = document.getElementById('va-name');
        if (n) n.dispatchEvent(new Event('input', { bubbles: true }));
      }
    } catch (e) {}
  }
  // logo just uploaded/changed
  window.addEventListener('va-logo-changed', function () { setTimeout(apply, 80); });
  // design switched while a logo already exists (no event fires for pickDesign)
  var lastKey = null;
  setInterval(function () {
    var k = (window.sel && window.sel.key) || null;
    if (k !== lastKey) { lastKey = k; apply(); }
  }, 900);
})();


/* ===== Replace the built-in icon with the customer's logo =====
   When "Hide this design's built-in icon" (the remove-icon control) is ticked
   and a logo exists, measure the design's own icon (.va-mark) bounding box (mm,
   from its gallery tile) and size + centre the logo into that exact area, so the
   logo lands where the icon was. Rides logoScale/logoX/logoY so server-side
   print matches the preview. Scale clamped to the size slider's 40-220% so a
   large decorative mark can't blow the logo up. Identical file on both themes. */
(function () {
  function iconBox() {
    try {
      // Match the current design's gallery tile by name (tiles always render the
      // icon, regardless of the selected/hide-mark state — robust source).
      var lbl = window.sel && window.sel.label;
      var svg = document.querySelector('#va-track .va-di.sel svg');
      if (!svg && lbl) {
        var tiles = document.querySelectorAll('#va-track .va-di:not(.va-di-upl)');
        for (var i = 0; i < tiles.length; i++) {
          var nm = tiles[i].querySelector('.va-di-name');
          if (nm && nm.textContent.trim() === lbl) { svg = tiles[i].querySelector('svg'); break; }
        }
      }
      if (!svg) return null;
      var marks = svg.querySelectorAll('.va-mark');
      if (!marks.length) return null;
      var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9, any = false;
      [].forEach.call(marks, function (m) {
        try { var b = m.getBBox(); if (b.width || b.height) { any = true; x0 = Math.min(x0, b.x); y0 = Math.min(y0, b.y); x1 = Math.max(x1, b.x + b.width); y1 = Math.max(y1, b.y + b.height); } } catch (e) {}
      });
      if (!any || x1 <= x0 || y1 <= y0) return null;
      return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
    } catch (e) { return null; }
  }
  function placeInIcon() {
    if (!window.customLogo) return;
    var box = iconBox(); if (!box) return;
    var d = window.sel || {};
    var W = d.w || 44.958, H = d.h || 19.05;
    var bw = W * 0.30, bh = H * 0.45;
    var scale = Math.max(0.4, Math.min(2.2, Math.min(box.w / bw, box.h / bh)));
    window.logoScale = scale;
    window.logoX = Math.max(-30, Math.min(30, (box.x + box.w / 2) - W / 2));
    window.logoY = Math.max(-14, Math.min(14, (box.y + box.h / 2) - H / 2));
    var sl = document.getElementById('va-logo-scale'); if (sl) { try { sl.value = Math.round(scale * 100); } catch (e) {} }
    var sv = document.getElementById('va-logo-scaleval'); if (sv) sv.textContent = Math.round(scale * 100) + '%';
    if (typeof window.renderAll === 'function') window.renderAll();
  }
  // capture phase → the tile keeps its icon regardless of the strip, so measuring is safe
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.id === 'va-logo-hidemark' && t.checked) setTimeout(placeInIcon, 0);
  }, true);
  // logo uploaded/changed while "hide icon" is already ticked
  window.addEventListener('va-logo-changed', function () {
    var cb = document.getElementById('va-logo-hidemark');
    if (cb && cb.checked && window.customLogo) setTimeout(placeInIcon, 90);
  });
})();


/* ===== Gesture coach-mark =====
   When a logo is added, pop a small fixed animated hint card that teaches how to
   position it: PINCH to resize + one-finger DRAG on touch; DRAG + size-slider on
   mouse. Fixed to the viewport so it's seen no matter where the (far-below-the-
   fold) interactive preview sits. Once per session; auto-dismisses after a few
   seconds or on tap of its X. Identical on both themes. */
(function () {
  var KEY = 'va_logo_coach';
  function seen() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function css() {
    if (document.getElementById('va-coach-css')) return;
    var s = document.createElement('style'); s.id = 'va-coach-css';
    s.textContent =
      '.va-coach{position:fixed;left:50%;bottom:118px;z-index:2147483000;display:flex;align-items:center;gap:14px;background:linear-gradient(120deg,#1c1140,#241653);border:1px solid rgba(124,77,255,.55);border-radius:16px;padding:12px 14px 12px 16px;box-shadow:0 16px 46px rgba(6,3,20,.6);max-width:calc(100vw - 24px);transform:translate(-50%,0);animation:vaCoachIn .32s cubic-bezier(.2,.9,.2,1) both;}'
      + '.va-coach.out{animation:vaCoachOut .32s ease forwards;}'
      + '@keyframes vaCoachIn{from{opacity:0;transform:translate(-50%,14px)}to{opacity:1;transform:translate(-50%,0)}}'
      + '@keyframes vaCoachOut{to{opacity:0;transform:translate(-50%,10px)}}'
      + '.va-coach-stage{position:relative;flex:0 0 auto;width:64px;height:32px;}'
      + '.va-coach-dot{position:absolute;top:50%;margin-top:-8px;width:16px;height:16px;border-radius:50%;background:#fff;box-shadow:0 2px 8px rgba(124,77,255,.8),0 0 0 3px rgba(124,77,255,.5);}'
      + '.va-coach-dot.l{left:2px;animation:vaCoachPL 1.7s cubic-bezier(.5,0,.5,1) infinite;}'
      + '.va-coach-dot.r{right:2px;animation:vaCoachPR 1.7s cubic-bezier(.5,0,.5,1) infinite;}'
      + '@keyframes vaCoachPL{0%,100%{transform:translateX(0)}46%{transform:translateX(23px)}}'
      + '@keyframes vaCoachPR{0%,100%{transform:translateX(0)}46%{transform:translateX(-23px)}}'
      + '.va-coach-drag{position:absolute;top:50%;left:50%;margin:-9px 0 0 -9px;width:18px;height:18px;border-radius:50%;background:#fff;box-shadow:0 2px 8px rgba(124,77,255,.8),0 0 0 3px rgba(124,77,255,.5);animation:vaCoachDrag 1.9s ease-in-out infinite;}'
      + '@keyframes vaCoachDrag{0%,100%{transform:translateX(-22px)}50%{transform:translateX(22px)}}'
      + '.va-coach-txt{color:#fff;font-weight:800;font-size:13.5px;line-height:1.3;}'
      + '.va-coach-txt small{display:block;font-weight:600;font-size:11.5px;color:#dccffb;margin-top:2px;}'
      + '.va-coach-x{flex:0 0 auto;align-self:flex-start;background:none;border:0;color:#9c93bf;font-size:18px;line-height:1;cursor:pointer;padding:0 2px;margin:-2px -2px 0 2px;}'
      + '.va-coach-x:hover{color:#fff;}';
    document.head.appendChild(s);
  }
  function show() {
    if (seen() || !window.customLogo || document.querySelector('.va-coach')) return;
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    css();
    var touch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
    var card = document.createElement('div'); card.className = 'va-coach'; card.setAttribute('role', 'status');
    card.innerHTML = (touch
      ? '<div class="va-coach-stage"><span class="va-coach-dot l"></span><span class="va-coach-dot r"></span></div>'
        + '<div class="va-coach-txt">Pinch to resize your logo<small>&mdash; drag it with one finger to move</small></div>'
      : '<div class="va-coach-stage"><span class="va-coach-drag"></span></div>'
        + '<div class="va-coach-txt">Drag your logo to move it<small>&mdash; use the size slider to resize</small></div>')
      + '<button type="button" class="va-coach-x" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(card);
    var done = false;
    function dismiss() { if (done) return; done = true; card.classList.add('out'); setTimeout(function () { try { card.remove(); } catch (e) {} }, 340); }
    card.querySelector('.va-coach-x').addEventListener('click', dismiss);
    setTimeout(dismiss, 6500);
  }
  window.addEventListener('va-logo-changed', function () { setTimeout(show, 300); });
})();

